export const RESET_STATE = 'RESET_STATE'

export const INIT = 'INIT'

export const GET_MYPROFILE_REQUEST = 'GET_MYPROFILE_REQUEST'
export const GET_MYPROFILE_SUCCESS = 'GET_MYPROFILE_SUCCESS'
export const GET_MYPROFILE_FAILURE = 'GET_MYPROFILE_FAILURE'

export const UPDATE_MYPROFILE_REQUEST = 'UPDATE_MYPROFILE_REQUEST'
export const UPDATE_MYPROFILE_SUCCESS = 'UPDATE_MYPROFILE_SUCCESS'
export const UPDATE_MYPROFILE_FAILURE = 'UPDATE_MYPROFILE_FAILURE'

export const CHANGE_MYPASSWORD_REQUEST = 'CHANGE_MYPASSWORD_REQUEST'
export const CHANGE_MYPASSWORD_SUCCESS = 'CHANGE_MYPASSWORD_SUCCESS'
export const CHANGE_MYPASSWORD_FAILURE = 'CHANGE_MYPASSWORD_FAILURE'

export const UPLOAD_MYAVATAR_REQUEST = 'UPLOAD_MYAVATAR_REQUEST'
export const UPLOAD_MYAVATAR_SUCCESS = 'UPLOAD_MYAVATAR_SUCCESS'
export const UPLOAD_MYAVATAR_FAILURE = 'UPLOAD_MYAVATAR_FAILURE'

export const GET_MYDEALER_REQUEST = 'GET_MYDEALER_REQUEST'
export const GET_MYDEALER_SUCCESS = 'GET_MYDEALER_SUCCESS'
export const GET_MYDEALER_FAILURE = 'GET_MYDEALER_FAILURE'

export const REGISTER_MYDEALER_REQUEST = 'REGISTER_MYDEALER_REQUEST'
export const REGISTER_MYDEALER_SUCCESS = 'REGISTER_MYDEALER_SUCCESS'
export const REGISTER_MYDEALER_FAILURE = 'REGISTER_MYDEALER_FAILURE'

export const UPDATE_MYDEALER_REQUEST = 'UPDATE_MYDEALER_REQUEST'
export const UPDATE_MYDEALER_SUCCESS = 'UPDATE_MYDEALER_SUCCESS'
export const UPDATE_MYDEALER_FAILURE = 'UPDATE_MYDEALER_FAILURE'

export const GET_MYSITES_REQUEST = 'GET_MYSITES_REQUEST'
export const GET_MYSITES_SUCCESS = 'GET_MYSITES_SUCCESS'
export const GET_MYSITES_FAILURE = 'GET_MYSITES_FAILURE'

export const GET_IDTOKEN_IPAUTH_REQUEST = 'GET_IDTOKEN_IPAUTH_REQUEST'
export const GET_IDTOKEN_IPAUTH_SUCCESS = 'GET_IDTOKEN_IPAUTH_SUCCESS'
export const GET_IDTOKEN_IPAUTH_FAILURE = 'GET_IDTOKEN_IPAUTH_FAILURE'

export const SEND_PASSWORDRESET_EMAIL_REQUEST = 'SEND_PASSWORDRESET_EMAIL_REQUEST'
export const SEND_PASSWORDRESET_EMAIL_SUCCESS = 'SEND_PASSWORDRESET_EMAIL_SUCCESS'
export const SEND_PASSWORDRESET_EMAIL_FAILURE = 'SEND_PASSWORDRESET_EMAIL_FAILURE'

export const SEND_EMAILCHANGE_EMAIL_REQUEST = 'SEND_EMAILCHANGE_EMAIL_REQUEST'
export const SEND_EMAILCHANGE_EMAIL_SUCCESS = 'SEND_EMAILCHANGE_EMAIL_SUCCESS'
export const SEND_EMAILCHANGE_EMAIL_FAILURE = 'SEND_EMAILCHANGE_EMAIL_FAILURE'

export const OPEN_PROFILE = 'OPEN_PROFILE'

export const INIT_AUTH0 = 'INIT_AUTH0'
export const LOAD_LAST_SESSION = 'LOAD_LAST_SESSION'
export const SET_SESSION = 'SET_SESSION'
export const CLEAR_SESSION = 'CLEAR_SESSION'
export const UPDATE_USERINFO = 'UPDATE_USERINFO'

export const START_CHECKING_SESSION = 'START_CHECKING_SESSION'
export const STOP_CHECKING_SESSION = 'STOP_CHECKING_SESSION'

export const HANDLE_AUTHENTICATION_REQUEST = 'HANDLE_AUTHENTICATION_REQUEST'
export const HANDLE_AUTHENTICATION_SUCCESS = 'HANDLE_AUTHENTICATION_SUCCESS'
export const HANDLE_AUTHENTICATION_FAILURE = 'HANDLE_AUTHENTICATION_FAILURE'

export const CHECK_SESSION_REQUEST = 'CHECK_SESSION_REQUEST'
export const CHECK_SESSION_SUCCESS = 'CHECK_SESSION_SUCCESS'
export const CHECK_SESSION_FAILURE = 'CHECK_SESSION_FAILURE'

export const MFA_SET_TOKEN = 'MFA_SET_TOKEN'
export const MFA_CLEAR = 'MFA_CLEAR'
export const MFA_SET_AUTHENTICATORS = 'MFA_SET_AUTHENTICATORS'
export const MFA_SET_PENDING_ENROLLMENT = 'MFA_SET_PENDING_ENROLLMENT'
export const MFA_CLEAR_PENDING_ENROLLMENT = 'MFA_CLEAR_PENDING_ENROLLMENT'
export const MFA_SET_ENROLL_STATUS = 'MFA_SET_ENROLL_STATUS'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js